import React, {Fragment, Suspense} from 'react';

import Common from "../../Common/Common";
import {Route} from "react-router-dom";

class Messages extends React.Component{

    render () {
        return (
            <Common pageTitle={"Messages"} mainContent={
                <h1>Messages Screen</h1>
            }/>
        )
    }
}

export default Messages;
